// import './icons/icons__config'; // icon font import
import './sprites';
import debug from "debug";

const log = debug('site__vegkit');


$(()=>{
	log('ready');
});



// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/components/site/index.js